import { useUserStore } from '@/stores/user'
import http, { createInstance } from '@/utils/http'

const PRIVILEGE_TYPE = {
  PERSONAL_BOX: 17,
}

const tokenStore = {
  token: '',
  expiredAt: 0,
  domain: 0,
}
const refreshToken = async (domain: number) => {
  const { code, token } = await http.post('/auth/grant', {
    privilege_type: PRIVILEGE_TYPE.PERSONAL_BOX,
    source_id: null,
    domain: domain,
  })

  if (code === 0) {
    return token as string
  }
}

const getToken = async (domain: number) => {
  if (tokenStore.expiredAt < Date.now() || domain !== tokenStore.domain) {
    const token = await refreshToken(domain)
    Object.assign(tokenStore, {
      token: `Bearer ${token}`,
      expiredAt: Date.now() + 60 * 1000,
      domain,
    })
  }

  return tokenStore.token
}

export const getFSToken = getToken

const boxApi = createInstance('', 'fs')
boxApi.interceptors.request.use(async (config) => {
  config.withCredentials = true
  config.domain ??= 0

  config.baseURL = useUserStore.getState().domainCurrentServiceMap[config.domain]
  // config.baseURL = 'https://platform.glows.ai'

  if (!config.baseURL) {
    throw {
      code: -7,
      message: 'target service not found',
    }
  }

  const token = await getToken(config.domain)

  if (token) {
    config.headers = {
      ...(config.headers || {}),
      Authorization: token,
    }
  }

  return config
})

export default boxApi
